import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import { omni_axios_instance } from 'utils/axios';
import _ from 'lodash';
import { toastr } from 'react-redux-toastr';

class ReatailerPopUp extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      showModal: this.props.show || false,
      retailerList: [],
      selectedAll: false,
      loading: true,
      saving: false
    };
    this.onModalHide = this.onModalHide.bind(this);
    this.handleUpdate = this.handleUpdate.bind(this);
    this.handleCheckbox = this.handleCheckbox.bind(this);
    this.selectAll = this.selectAll.bind(this);
  }

  componentDidMount() {
    const existing = this.props.selectedRetailers.retailers || [];
    omni_axios_instance.get('/retailers').then(response => {
      const retailerList = existing.map(item => ({ ...item }));
      response.data.forEach(retailer => {
        if (!retailerList.some(item =>
          String(item.retailer && (item.retailer._id || item.retailer)) === String(retailer._id)
        )) {
          retailerList.push({ retailer, flag: false });
        }
      });
      this.setState({
        retailerList: _.sortBy(retailerList, item =>
          ((item.retailer && item.retailer.name) || '').toLowerCase()
        ),
        loading: false
      });
    }).catch(() => {
      toastr.error('ERROR', 'Unable to load retailers. Close this window and try again.');
    });
  }

  handleCheckbox = (e, value) => {
    const retailerId = e.target.value;
    const checked = e.target.checked;
    this.setState(state => ({
      retailerList: state.retailerList.map(item =>
        String(item.retailer && (item.retailer._id || item.retailer)) === retailerId
          ? { ...item, flag: checked }
          : item
      )
    }));
  };

  selectAll = e => {
    e.preventDefault();
    let { retailerList } = this.state;
    // console.log(selectedAll, e.target.checked);
    _.forEach(retailerList, (item, key) => {
      item.flag = e.target.checked;
    });

    this.setState({
      retailerList: retailerList,
      selectedAll: e.target.checked
    });
  };

  handleUpdate(e) {
    e.preventDefault();
    if (this.state.loading || this.state.saving) return;
    let { selectedRetailers, getBrand } = this.props;
    const retailers = this.state.retailerList
      .filter(item => item.retailer)
      .map(item => ({
        retailer: item.retailer._id || item.retailer,
        flag: !!item.flag
      }));
    this.setState({ saving: true });

    omni_axios_instance
      .put(`/brands/${selectedRetailers._id}`, { retailers })
      .then(res => {
        if (res.status === 200) {
          toastr.success('SUCCESS', 'Successfully updated');
          this.onModalHide();
          getBrand();
        }
      }).catch(() => {
        this.setState({ saving: false });
        toastr.error('ERROR', 'Unable to update retailers. Please try again.');
      });
  }

  onModalHide() {
    let { callback } = this.props;
    this.setState(
      {
        showModal: false
      },
      () => {
        callback && callback();
      }
    );
  }
  render() {
    let { showModal, retailerList, loading, saving } = this.state;
    let { selectedRetailers } = this.props;
    // console.log(selectedRetailers,'selectedRetailers')
    return (
      <div className="modal-container">
        <Modal
          animation={false}
          autoFocus={false}
          enforceFocus={false}
          className="RetailerPopUpModal"
          show={showModal}
          onHide={() => this.onModalHide()}
        >
          <Modal.Header closeButton>
            <Modal.Title>{selectedRetailers.name}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {loading && <p>Loading retailers...</p>}
            <form className="checkListForm">
              {/*  <div className="isSelectAll">
                <input type="checkbox" onChange={(e) => this.selectAll(e)} checked={selectedAll ? true : false}/>
                 <label>Select All</label>
              </div> */}
              <div className="checkListItems">
                {retailerList.map((item, index) => {
                  if (!_.isEmpty(item.retailer)) {
                    return (
                      <div className="retailerCheckList" key={index}>
                        <input
                          type="checkbox"
                          className="retailerCheckbox"
                          checked={!!item.flag}
                          disabled={saving}
                          onChange={e => this.handleCheckbox(e, item)}
                          value={item.retailer._id}
                        />
                        <label>{item.retailer.name}</label>
                      </div>
                    );
                  }
                })}
              </div>
            </form>
            <div className="popup-btn">
              <Button onClick={this.onModalHide}>Cancel</Button>
              <Button bsStyle="primary" disabled={loading || saving} onClick={e => this.handleUpdate(e)}>
                Update
              </Button>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

export default ReatailerPopUp;
